export interface InvoiceDocumentSettings {
  pvMode: "without_attachments" | "with_attachments" | null
  approvalAttachments: boolean
  manDaysRegister: boolean
}

export interface CustomerInvoicingSettings {
  useDifferentAddress: boolean
  address: { attention: string; street: string; postalCode: string; city: string; country: string }
  emails: string
  reverseCharge: boolean
  vatExempt: boolean
  vatRate: 0 | 9 | 21
  customerVatId: string
  paymentTermDays: number | null
  gAccountPercentage: string | null
  internalNote: string
  invoice: InvoiceDocumentSettings
  attachment: InvoiceDocumentSettings
  maxFileSizeKb: number | null
  maxAttachments: number | null
  maxAmount: string | null
}

export function createCustomerInvoicingSettings(
  settings?: Partial<CustomerInvoicingSettings>
): CustomerInvoicingSettings {
  return {
    useDifferentAddress: false,
    emails: "",
    reverseCharge: false,
    vatExempt: false,
    vatRate: 21,
    customerVatId: "",
    paymentTermDays: null,
    gAccountPercentage: null,
    internalNote: "",
    maxFileSizeKb: null,
    maxAttachments: null,
    maxAmount: null,
    ...settings,
    address: {
      attention: "",
      street: "",
      postalCode: "",
      city: "",
      country: "Nederland",
      ...settings?.address
    },
    invoice: {
      pvMode: null,
      approvalAttachments: false,
      manDaysRegister: false,
      ...settings?.invoice
    },
    attachment: {
      pvMode: null,
      approvalAttachments: false,
      manDaysRegister: false,
      ...settings?.attachment
    }
  }
}
